import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import { IconButton } from "@mui/material";
import { useRef } from "react";
import { RootStyle } from "./Locker.style";
import { LOCKER_SCROLL_OFFSET } from "./Locker.constants";

export function Locker(props: { isOpen: boolean; onClick?: () => void }) {
  const { isOpen, onClick } = props;

  const lockerRef = useRef<HTMLDivElement>(null);

  const handleClick = () => {
    if (!isOpen && lockerRef?.current) {
      // NOTE: We use setTimeout to ensure the scroll happens after the DOM update
      setTimeout(() => {
        const { top: lockerTop } = lockerRef.current!.getBoundingClientRect();
        const top = lockerTop + window.scrollY - LOCKER_SCROLL_OFFSET;
        window.scrollTo({ top, behavior: "smooth" });
      }, 0);
    }

    onClick?.();
  };

  return (
    <RootStyle ref={lockerRef}>
      <IconButton color="primary" size="small" onClick={handleClick}>
        {isOpen ? (
          <LockOpenIcon fontSize={"small"} color={"secondary"} />
        ) : (
          <LockIcon fontSize={"small"} />
        )}
      </IconButton>
    </RootStyle>
  );
}
